(() => {
  const offerSectionSelector = '#shopify-section-template--31196359524697__offer, #offers';
  const scrollToOffer = (event) => {
    const eventElement = event.target instanceof Element ? event.target : event.target?.parentElement;
    const link = eventElement?.closest('.liora-fo__announcement-link, .liora-sticky-cta__action a');
    if (!link) return;

    const target = document.querySelector(offerSectionSelector);
    if (!target) return;

    event.preventDefault();
    const scroller = document.querySelector('.page-wrapper');
    const isPageWrapperScroller = scroller && scroller.scrollHeight > scroller.clientHeight;
    const scrollTop = isPageWrapperScroller
      ? target.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop - 12
      : target.getBoundingClientRect().top + window.scrollY - 12;
    const startTop = isPageWrapperScroller ? scroller.scrollTop : window.scrollY;
    const distance = scrollTop - startTop;
    const duration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 800;
    if (!duration) {
      if (isPageWrapperScroller) scroller.scrollTo({ top: scrollTop, behavior: 'auto' });
      else window.scrollTo({ top: scrollTop, behavior: 'auto' });
      return;
    }

    const startTime = performance.now();
    const animate = (now) => {
      const progress = Math.min(1, (now - startTime) / duration);
      const eased = progress;
      const nextTop = startTop + distance * eased;
      if (isPageWrapperScroller) scroller.scrollTop = nextTop;
      else window.scrollTo(0, nextTop);
      if (progress < 1) window.requestAnimationFrame(animate);
    };
    window.requestAnimationFrame(animate);
  };

  document.addEventListener('click', scrollToOffer, true);
  document.querySelectorAll('.liora-fo__announcement-link, .liora-sticky-cta__action a').forEach((link) => {
    link.addEventListener('click', scrollToOffer, true);
  });

  const sticky = document.querySelector('[data-liora-sticky-cta]');
  const hero = document.querySelector('.liora-fo__hero-v2');
  const offer = document.querySelector(offerSectionSelector);
  if (!sticky || !hero || !offer) return;

  let ticking = false;
  const scrollContainer = document.querySelector('.page-wrapper');
  const updateVisibility = () => {
    const heroRect = hero.getBoundingClientRect();
    const offerRect = offer.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const isDesktop = window.matchMedia('(min-width: 750px)').matches;
    const stickyHeight = sticky.offsetHeight;
    const hasScrolledPastHero = isDesktop
      ? heroRect.bottom < viewportHeight * 0.15
      : heroRect.bottom < viewportHeight * 0.65;
    const offerIsStillAhead = isDesktop
      ? offerRect.top > stickyHeight + 16
      : offerRect.top > viewportHeight - stickyHeight - 16;
    const visible = hasScrolledPastHero && offerIsStillAhead;
    sticky.classList.toggle('is-visible', visible);
    ticking = false;
  };
  const scheduleUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateVisibility);
  };

  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  scrollContainer?.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate, { passive: true });
  updateVisibility();
})();
